// AUTO-GENERATED by scripts/generate-plugin-ui-registry.ts
// Do not edit manually — run `npm run gen:plugin-ui` to regenerate.

import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

export interface GeneratedUiRoute {
  pluginId: string;
  path: string;
  label?: string;
  moduleCode: string;
  Component: LazyExoticComponent<ComponentType>;
  navItem?: {
    key: string;
    label: string;
    path?: string;
    icon?: string;
    section?: string;
    navGroup?: string;
    navOrder?: number;
    desktopOnly?: boolean;
  };
  public: boolean;
}

export interface GeneratedPublicRoute {
  pluginId: string;
  pattern: string;
  label?: string;
  Component: LazyExoticComponent<ComponentType>;
}

export interface GeneratedNavGroup {
  pluginId: string;
  key: string;
  label: string;
  icon?: string;
  order?: number;
  moduleCode?: string;
}

export interface GeneratedLandingPath {
  pluginId: string;
  landingRoute: string;
  baseModule: string;
}

export const PLUGIN_UI_ROUTES: GeneratedUiRoute[] = [
  {
    pluginId: "beauty",
    path: "beauty",
    moduleCode: "beauty-base",
    Component: lazy(() => import("@striker/plugin-beauty/ui")),
    navItem: {
          "key": "beauty",
          "label": "Estetica",
          "path": "/tenant/beauty",
          "navGroup": "beauty",
          "navOrder": 90
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/treatments",
    moduleCode: "beauty-base",
    Component: lazy(() => import("@striker/plugin-beauty/ui/treatments")),
    navItem: {
          "key": "beauty-treatments",
          "label": "Trattamenti",
          "path": "/tenant/beauty/treatments",
          "navGroup": "beauty",
          "navOrder": 1
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/cabins",
    moduleCode: "beauty-cabins",
    Component: lazy(() => import("@striker/plugin-beauty/ui/cabins")),
    navItem: {
          "key": "beauty-cabins",
          "label": "Cabine",
          "path": "/tenant/beauty/cabins",
          "navGroup": "beauty",
          "navOrder": 2
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/operators",
    moduleCode: "beauty-operators",
    Component: lazy(() => import("@striker/plugin-beauty/ui/operators")),
    navItem: {
          "key": "beauty-operators",
          "label": "Operatori",
          "path": "/tenant/beauty/operators",
          "navGroup": "beauty",
          "navOrder": 3
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/shifts",
    moduleCode: "beauty-operators",
    Component: lazy(() => import("@striker/plugin-beauty/ui/shifts")),
    navItem: {
          "key": "beauty-shifts",
          "label": "Turni",
          "path": "/tenant/beauty/shifts",
          "navGroup": "beauty",
          "navOrder": 4
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/bookings",
    moduleCode: "beauty-bookings",
    Component: lazy(() => import("@striker/plugin-beauty/ui/bookings")),
    navItem: {
          "key": "beauty-bookings",
          "label": "Prenotazioni",
          "path": "/tenant/beauty/bookings",
          "navGroup": "beauty",
          "navOrder": 5
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/analytics",
    moduleCode: "beauty-analytics",
    Component: lazy(() => import("@striker/plugin-beauty/ui/analytics")),
    navItem: {
          "key": "beauty-analytics",
          "label": "Analytics",
          "path": "/tenant/beauty/analytics",
          "section": "analytics",
          "navGroup": "beauty",
          "navOrder": 12
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/clients",
    moduleCode: "beauty-clients",
    Component: lazy(() => import("@striker/plugin-beauty/ui/clients")),
    navItem: {
          "key": "beauty-clients",
          "label": "Clienti",
          "path": "/tenant/beauty/clients",
          "icon": "users",
          "navGroup": "beauty",
          "navOrder": 7
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/products",
    moduleCode: "beauty-base",
    Component: lazy(() => import("@striker/plugin-beauty/ui/products")),
    navItem: {
          "key": "beauty-products",
          "label": "Prodotti",
          "path": "/tenant/beauty/products",
          "icon": "box",
          "navGroup": "beauty",
          "navOrder": 8
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/packages",
    moduleCode: "beauty-base",
    Component: lazy(() => import("@striker/plugin-beauty/ui/packages")),
    navItem: {
          "key": "beauty-packages",
          "label": "Pacchetti",
          "path": "/tenant/beauty/packages",
          "icon": "gift",
          "navGroup": "beauty",
          "navOrder": 9
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/planning",
    moduleCode: "beauty-bookings",
    Component: lazy(() => import("@striker/plugin-beauty/ui/planning")),
    navItem: {
          "key": "beauty-planning",
          "label": "Planning",
          "path": "/tenant/beauty/planning",
          "icon": "calendar",
          "navGroup": "beauty",
          "navOrder": 6
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/stock",
    moduleCode: "beauty-stock",
    Component: lazy(() => import("@striker/plugin-beauty/ui/stock")),
    navItem: {
          "key": "beauty-stock",
          "label": "Magazzino",
          "path": "/tenant/beauty/stock",
          "icon": "box",
          "navGroup": "beauty",
          "navOrder": 10
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/loyalty",
    moduleCode: "beauty-loyalty",
    Component: lazy(() => import("@striker/plugin-beauty/ui/loyalty")),
    navItem: {
          "key": "beauty-loyalty",
          "label": "Fidelizzazione",
          "path": "/tenant/beauty/loyalty",
          "icon": "star",
          "navGroup": "beauty",
          "navOrder": 13
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/marketing",
    moduleCode: "beauty-marketing",
    Component: lazy(() => import("@striker/plugin-beauty/ui/marketing")),
    navItem: {
          "key": "beauty-marketing",
          "label": "Marketing",
          "path": "/tenant/beauty/marketing",
          "icon": "megaphone",
          "section": "analytics",
          "navGroup": "beauty",
          "navOrder": 14
    },
    public: false
  },
  {
    pluginId: "beauty",
    path: "beauty/pos",
    moduleCode: "beauty-pos",
    Component: lazy(() => import("@striker/plugin-beauty/ui/pos")),
    navItem: {
          "key": "beauty-pos",
          "label": "Cassa",
          "path": "/tenant/beauty/pos",
          "icon": "credit-card",
          "navGroup": "beauty",
          "navOrder": 11
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym",
    moduleCode: "gym-base",
    Component: lazy(() => import("@striker/plugin-gym/ui")),
    navItem: {
          "key": "gym",
          "label": "Dashboard",
          "path": "/tenant/gym",
          "icon": "dumbbell",
          "navGroup": "gym",
          "navOrder": 100
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym/members",
    moduleCode: "gym-members",
    Component: lazy(() => import("@striker/plugin-gym/ui/members")),
    navItem: {
          "key": "gym-members",
          "label": "Soci",
          "path": "/tenant/gym/members",
          "icon": "users",
          "navGroup": "gym",
          "navOrder": 2
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym/memberships",
    moduleCode: "gym-base",
    Component: lazy(() => import("@striker/plugin-gym/ui/memberships")),
    navItem: {
          "key": "gym-memberships",
          "label": "Abbonamenti",
          "path": "/tenant/gym/memberships",
          "icon": "credit-card",
          "navGroup": "gym",
          "navOrder": 1
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym/check-ins",
    moduleCode: "gym-checkins",
    Component: lazy(() => import("@striker/plugin-gym/ui/check-ins")),
    navItem: {
          "key": "gym-checkins",
          "label": "Accessi",
          "path": "/tenant/gym/check-ins",
          "icon": "door-open",
          "navGroup": "gym",
          "navOrder": 3
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym/coaches",
    moduleCode: "gym-coaches",
    Component: lazy(() => import("@striker/plugin-gym/ui/coaches")),
    navItem: {
          "key": "gym-coaches",
          "label": "Coach",
          "path": "/tenant/gym/coaches",
          "icon": "user-cog",
          "navGroup": "gym",
          "navOrder": 4
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym/workout-plans",
    moduleCode: "gym-workout",
    Component: lazy(() => import("@striker/plugin-gym/ui/workout-plans")),
    navItem: {
          "key": "gym-workout",
          "label": "Schede",
          "path": "/tenant/gym/workout-plans",
          "icon": "clipboard-list",
          "navGroup": "gym",
          "navOrder": 5
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym/programs",
    moduleCode: "gym-workout",
    Component: lazy(() => import("@striker/plugin-gym/ui/programs")),
    navItem: {
          "key": "gym-programs",
          "label": "Percorsi",
          "path": "/tenant/gym/programs",
          "icon": "route",
          "navGroup": "gym",
          "navOrder": 6
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym/nutrition",
    moduleCode: "gym-nutrition",
    Component: lazy(() => import("@striker/plugin-gym/ui/nutrition")),
    navItem: {
          "key": "gym-nutrition",
          "label": "Nutrizione",
          "path": "/tenant/gym/nutrition",
          "icon": "apple",
          "navGroup": "gym",
          "navOrder": 7
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym/analytics",
    moduleCode: "gym-analytics",
    Component: lazy(() => import("@striker/plugin-gym/ui/analytics")),
    navItem: {
          "key": "gym-analytics",
          "label": "Analytics",
          "path": "/tenant/gym/analytics",
          "icon": "chart",
          "section": "analytics",
          "navGroup": "gym",
          "navOrder": 9
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym/loyalty",
    moduleCode: "gym-loyalty",
    Component: lazy(() => import("@striker/plugin-gym/ui/loyalty")),
    navItem: {
          "key": "gym-loyalty",
          "label": "Fidelizzazione",
          "path": "/tenant/gym/loyalty",
          "icon": "star",
          "navGroup": "gym",
          "navOrder": 10
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym/marketing",
    moduleCode: "gym-marketing",
    Component: lazy(() => import("@striker/plugin-gym/ui/marketing")),
    navItem: {
          "key": "gym-marketing",
          "label": "Marketing",
          "path": "/tenant/gym/marketing",
          "icon": "megaphone",
          "section": "analytics",
          "navGroup": "gym",
          "navOrder": 11
    },
    public: false
  },
  {
    pluginId: "gym",
    path: "gym/pos",
    moduleCode: "gym-pos",
    Component: lazy(() => import("@striker/plugin-gym/ui/pos")),
    navItem: {
          "key": "gym-pos",
          "label": "Cassa",
          "path": "/tenant/gym/pos",
          "icon": "credit-card",
          "navGroup": "gym",
          "navOrder": 8
    },
    public: false
  },
  {
    pluginId: "haccp",
    path: "haccp",
    moduleCode: "haccp-base",
    Component: lazy(() => import("@striker/plugin-haccp/ui")),
    navItem: {
          "key": "haccp",
          "label": "HACCP",
          "path": "/tenant/haccp",
          "icon": "haccp",
          "navOrder": 140
    },
    public: false
  },
  {
    pluginId: "hair",
    path: "hair",
    moduleCode: "hair-booking",
    Component: lazy(() => import("@striker/plugin-hair/ui")),
    navItem: {
          "key": "hair",
          "label": "Hair Sala",
          "path": "/tenant/hair",
          "icon": "scissors",
          "navGroup": "hair",
          "navOrder": 95
    },
    public: false
  },
  {
    pluginId: "hair",
    path: "hair/tv",
    moduleCode: "hair-booking",
    Component: lazy(() => import("@striker/plugin-hair/ui/tv")),
    navItem: {
          "key": "hair-tv",
          "label": "Lavagna TV",
          "path": "/tenant/hair/tv",
          "icon": "tv",
          "navGroup": "hair",
          "navOrder": 1
    },
    public: false
  },
  {
    pluginId: "hair",
    path: "hair/loyalty",
    moduleCode: "hair-fidelity",
    Component: lazy(() => import("@striker/plugin-hair/ui/loyalty")),
    navItem: {
          "key": "hair-loyalty",
          "label": "Fidelity",
          "path": "/tenant/hair/loyalty",
          "icon": "star",
          "navGroup": "hair",
          "navOrder": 2
    },
    public: false
  },
  {
    pluginId: "hello",
    path: "/hello",
    label: "Hello",
    moduleCode: "hello",
    Component: lazy(() => import("@striker/plugin-hello/ui/page")),
    navItem: {
          "key": "hello",
          "label": "Hello Demo",
          "icon": "star",
          "section": "main"
    },
    public: false
  },
  {
    pluginId: "portale",
    path: "/portale",
    label: "Portale",
    moduleCode: "portale-base",
    Component: lazy(() => import("@striker/plugin-portale/ui")),
    navItem: {
          "key": "portale",
          "label": "Portale",
          "icon": "store",
          "section": "public",
          "navOrder": 160
    },
    public: true
  },
  {
    pluginId: "restaurant",
    path: "menu",
    moduleCode: "restaurant-base",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/menu-hub")),
    navItem: {
          "key": "menu",
          "label": "Menu",
          "path": "/tenant/menu",
          "icon": "menu",
          "navGroup": "menu",
          "navOrder": 10
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "menu/products",
    moduleCode: "restaurant-base",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/menu")),
    navItem: {
          "key": "menu-products",
          "label": "Gestione Prodotti",
          "path": "/tenant/menu/products",
          "navGroup": "menu",
          "navOrder": 1
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "menu/categories",
    moduleCode: "restaurant-base",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/categories")),
    navItem: {
          "key": "menu-categories",
          "label": "Categorie",
          "path": "/tenant/menu/categories",
          "navGroup": "menu",
          "navOrder": 2
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "menu/subcategories",
    moduleCode: "restaurant-base",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/subcategories")),
    navItem: {
          "key": "menu-subcategories",
          "label": "Sottocategorie",
          "path": "/tenant/menu/subcategories",
          "navGroup": "menu",
          "navOrder": 3
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "menu/fixed-menus",
    moduleCode: "restaurant-base",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/fixed-menus")),
    public: false
  },
  {
    pluginId: "restaurant",
    path: "menu/modifiers",
    moduleCode: "restaurant-base",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/menu-engine")),
    navItem: {
          "key": "menu-modifiers",
          "label": "Modificatori",
          "path": "/tenant/menu/modifiers"
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "menu/price-schedules",
    moduleCode: "restaurant-base",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/menu-price-schedules")),
    public: false
  },
  {
    pluginId: "restaurant",
    path: "orders",
    moduleCode: "restaurant-pos",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/orders")),
    navItem: {
          "key": "orders",
          "label": "Ordini",
          "path": "/tenant/orders",
          "icon": "orders",
          "navOrder": 50
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "production/orders",
    moduleCode: "restaurant-pos",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/production-orders")),
    navItem: {
          "key": "production-orders",
          "label": "Schermo Comande",
          "path": "/tenant/production/orders",
          "icon": "orders",
          "navOrder": 60
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "production/orders-tablet",
    moduleCode: "restaurant-pos",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/production-orders-tablet")),
    navItem: {
          "key": "production-orders-tablet",
          "label": "Comande tablet",
          "path": "/tenant/production/orders-tablet",
          "icon": "orders",
          "navOrder": 70
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "staff",
    moduleCode: "restaurant-staff",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/staff")),
    navItem: {
          "key": "staff",
          "label": "Staff",
          "path": "/tenant/staff",
          "icon": "users",
          "navOrder": 80
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "tables",
    moduleCode: "restaurant-tables",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/tables")),
    navItem: {
          "key": "tables",
          "label": "Tavoli",
          "path": "/tenant/tables",
          "icon": "tables",
          "navGroup": "tables",
          "navOrder": 20
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "tables/manage",
    moduleCode: "restaurant-tables",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/tables-manage")),
    navItem: {
          "key": "tables-manage",
          "label": "Tavoli e sale",
          "path": "/tenant/tables/manage",
          "navGroup": "tables",
          "navOrder": 2
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "tables/rotation",
    moduleCode: "restaurant-tables",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/tables-rotation")),
    navItem: {
          "key": "tables-rotation",
          "label": "Rotazione tavoli",
          "path": "/tenant/tables/rotation",
          "navGroup": "tables",
          "navOrder": 1,
          "desktopOnly": true
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "reservations",
    moduleCode: "restaurant-reservations",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/reservations")),
    navItem: {
          "key": "reservations",
          "label": "Prenotazioni",
          "path": "/tenant/reservations",
          "icon": "reservations",
          "navOrder": 30
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "settings/hours",
    moduleCode: "restaurant-reservations",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/settings-hours")),
    navItem: {
          "key": "settings-hours",
          "label": "Impostazioni Locale",
          "path": "/tenant/settings/hours",
          "navGroup": "settings",
          "navOrder": 1
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "home",
    moduleCode: "restaurant-base",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/home")),
    navItem: {
          "key": "settings-home",
          "label": "Home pubblica",
          "path": "/tenant/home",
          "navGroup": "settings",
          "navOrder": 2
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "customers",
    moduleCode: "restaurant-crm",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/customers")),
    navItem: {
          "key": "customers",
          "label": "CRM Clienti",
          "path": "/tenant/customers",
          "icon": "users",
          "navOrder": 40
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "analytics",
    moduleCode: "restaurant-analytics",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/analytics")),
    navItem: {
          "key": "analytics",
          "label": "Analisi",
          "path": "/tenant/analytics",
          "icon": "dashboard",
          "navOrder": 110
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "loyalty",
    moduleCode: "restaurant-loyalty",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/loyalty")),
    navItem: {
          "key": "loyalty",
          "label": "Fidelizzazione",
          "path": "/tenant/loyalty",
          "icon": "star",
          "navOrder": 120
    },
    public: false
  },
  {
    pluginId: "restaurant",
    path: "marketing",
    moduleCode: "restaurant-marketing",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/marketing")),
    navItem: {
          "key": "marketing",
          "label": "Marketing",
          "path": "/tenant/marketing",
          "icon": "sms",
          "navOrder": 130
    },
    public: false
  },
  {
    pluginId: "sandbox-test",
    path: "sandbox-test",
    moduleCode: "sandbox-test",
    Component: lazy(() => import("@striker/plugin-sandbox-test/ui")),
    navItem: {
          "key": "sandbox-test",
          "label": "Sandbox Test",
          "path": "/tenant/sandbox-test",
          "icon": "star",
          "navOrder": 200
    },
    public: false
  },
  {
    pluginId: "support",
    path: "/support",
    label: "Support",
    moduleCode: "support-base",
    Component: lazy(() => import("@striker/plugin-support/ui")),
    navItem: {
          "key": "support",
          "label": "Supporto",
          "icon": "support",
          "navOrder": 180
    },
    public: false
  }
];

export const PLUGIN_PUBLIC_ROUTES: GeneratedPublicRoute[] = [
  {
    pluginId: "restaurant",
    pattern: "/r/:tenantSlug",
    label: "Public Home",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/public-home")),
  },
  {
    pluginId: "restaurant",
    pattern: "/r/:tenantSlug/menu",
    label: "Public Menu",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/public-menu")),
  },
  {
    pluginId: "restaurant",
    pattern: "/r/:tenantSlug/reserve",
    label: "Public Reserve",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/public-reserve")),
  },
  {
    pluginId: "restaurant",
    pattern: "/r/:tenantSlug/reserve/:bookingCode",
    label: "Public Reserve Manage",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/public-reserve-manage")),
  },
  {
    pluginId: "restaurant",
    pattern: "/r/:tenantSlug/t/:tableNumber",
    label: "Public Table Order",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/public-table-order")),
  },
  {
    pluginId: "restaurant",
    pattern: "/s/:tenantSlug",
    label: "Staff Sala",
    Component: lazy(() => import("@striker/plugin-restaurant/ui/staff-sala")),
  }
];

export const PLUGIN_NAV_GROUPS: GeneratedNavGroup[] = [
  {
    pluginId: "restaurant",
    key: "settings",
    label: "Configurazione",
    icon: "config",
    order: 150,
    moduleCode: "restaurant-base",
  }
];

export const PLUGIN_LANDING_PATHS: GeneratedLandingPath[] = [
  {
    pluginId: "beauty",
    landingRoute: "beauty",
    baseModule: "beauty-base"
  },
  {
    pluginId: "gym",
    landingRoute: "gym",
    baseModule: "gym-base"
  },
  {
    pluginId: "haccp",
    landingRoute: "haccp",
    baseModule: "haccp-base"
  },
  {
    pluginId: "hair",
    landingRoute: "hair",
    baseModule: "hair-base"
  },
  {
    pluginId: "portale",
    landingRoute: "portale",
    baseModule: "portale-base"
  },
  {
    pluginId: "restaurant",
    landingRoute: "home",
    baseModule: "restaurant-base"
  },
  {
    pluginId: "sandbox-test",
    landingRoute: "sandbox-test",
    baseModule: "sandbox-test"
  }
];

export const generatedPluginIds: string[] = [
  "beauty",
  "gym",
  "haccp",
  "hair",
  "hello",
  "portale",
  "restaurant",
  "sandbox-test",
  "support",
  "example"
];
